document.addEventListener('DOMContentLoaded', () => {
  const mobileMenus = document.querySelectorAll('[data-mobile-menu]');
  const siteHeader = document.querySelector('.site-header:not(.site-header--static)');
  const siteHeaderHero = siteHeader?.querySelector('.site-header__hero');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerPanel = cartDrawer?.querySelector('.cart-drawer__panel');
  const cartDrawerTriggers = document.querySelectorAll('[data-cart-drawer-open]');
  const productForms = document.querySelectorAll('[data-product-form]');
  const cartLabels = {
    cartUrl: cartDrawer?.dataset.cartUrl || '/cart',
    collectionsUrl: cartDrawer?.dataset.collectionsUrl || '/pages/colegios',
    continueUrl: cartDrawer?.dataset.continueUrl || cartDrawer?.dataset.collectionsUrl || '/pages/colegios',
    emptyTitle: cartDrawer?.dataset.emptyTitle || 'Tu carrito está vacío',
    emptyText: cartDrawer?.dataset.emptyText || 'Agrega tus productos favoritos para continuar con tu compra.',
    continueLabel: cartDrawer?.dataset.continueLabel || 'Seguir comprando',
    cartLabel: cartDrawer?.dataset.cartLabel || 'Ver carrito',
    checkoutLabel: cartDrawer?.dataset.checkoutLabel || 'Finalizar compra',
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
  }[character]));

  const normalizeSchoolSlug = (value) => String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/^\/?pages\/colegios\??/g, '')
    .replace(/^colegios?-/, '')
    .replace(/^colegio-/, '')
    .replace(/-(products?|productos?)$/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const formatMoney = (cents) => {
    const amount = Number(cents || 0) / 100;

    return new Intl.NumberFormat('es-MX', {
      style: 'currency',
      currency: 'MXN',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const shopifyAjaxUrl = (path) => {
    const root = window.Shopify?.routes?.root || '/';
    const normalizedRoot = root.endsWith('/') ? root : `${root}/`;

    return `${normalizedRoot}${String(path || '').replace(/^\/+/, '')}`;
  };

  const productReturnStorageKey = 'moottProductReturnUrl';

  const isColegiosUrl = (url) => (
    url.origin === window.location.origin
    && url.pathname.replace(/\/+$/, '') === '/pages/colegios'
  );

  const setStoredProductReturnUrl = (url) => {
    try {
      const returnUrl = new URL(url, window.location.origin);

      if (!isColegiosUrl(returnUrl)) return;

      window.sessionStorage.setItem(productReturnStorageKey, JSON.stringify({
        url: `${returnUrl.pathname}${returnUrl.search}${returnUrl.hash}`,
        timestamp: Date.now(),
      }));
    } catch (error) {
      // Ignore storage errors in private browsing or restricted contexts.
    }
  };

  const getStoredProductReturnUrl = () => {
    try {
      const rawValue = window.sessionStorage.getItem(productReturnStorageKey);
      const storedValue = rawValue ? JSON.parse(rawValue) : null;
      const storedUrl = storedValue?.url ? new URL(storedValue.url, window.location.origin) : null;
      const storedAt = Number(storedValue?.timestamp || 0);
      const referrerUrl = document.referrer ? new URL(document.referrer) : null;
      const isFresh = storedAt && Date.now() - storedAt < 30 * 60 * 1000;

      if (!storedUrl || !isFresh || !isColegiosUrl(storedUrl)) return '';
      if (referrerUrl && !isColegiosUrl(referrerUrl)) return '';

      return `${storedUrl.pathname}${storedUrl.search}${storedUrl.hash}`;
    } catch (error) {
      return '';
    }
  };

  const parseRatePriceToCents = (price) => {
    const amount = Number(String(price ?? '').replace(/[^0-9.-]/g, ''));

    return Number.isFinite(amount) ? Math.round(amount * 100) : null;
  };

  const updateCartCount = (itemCount) => {
    cartDrawerTriggers.forEach((trigger) => {
      let count = trigger.querySelector('.site-header__cart-count');

      if (itemCount > 0 && !count) {
        count = document.createElement('span');
        count.className = 'site-header__cart-count';
        trigger.append(count);
      }

      if (count) {
        count.textContent = itemCount;
        count.hidden = itemCount <= 0;
      }
    });
  };

  const updateStickyNavigation = () => {
    if (!siteHeader || !siteHeaderHero) return;

    const heroHeight = Math.ceil(siteHeaderHero.getBoundingClientRect().height);
    siteHeader.style.setProperty('--header-sticky-offset', `${heroHeight}px`);
  };

  updateStickyNavigation();
  window.addEventListener('load', updateStickyNavigation);
  window.addEventListener('resize', updateStickyNavigation);

  if ('ResizeObserver' in window && siteHeaderHero) {
    new ResizeObserver(updateStickyNavigation).observe(siteHeaderHero);
  }

  const scrollHintElements = new Set();

  const updateScrollHint = (element) => {
    const shell = element.closest('[data-scroll-hint-shell]');

    if (!shell) return;

    const isVisible = element.getClientRects().length > 0 && !element.hidden;
    const maxScrollLeft = Math.max(element.scrollWidth - element.clientWidth, 0);
    const hasOverflow = isVisible && maxScrollLeft > 2;
    const hasScrollLeft = hasOverflow && element.scrollLeft > 2;
    const hasScrollRight = hasOverflow && element.scrollLeft < maxScrollLeft - 2;

    shell.classList.toggle('is-scrollable', hasOverflow);
    shell.classList.toggle('has-scroll-left', hasScrollLeft);
    shell.classList.toggle('has-scroll-right', hasScrollRight);
  };

  const refreshScrollHints = () => {
    window.requestAnimationFrame(() => {
      document.querySelectorAll('[data-scroll-hint]').forEach((element) => {
        if (!scrollHintElements.has(element)) {
          scrollHintElements.add(element);
          element.addEventListener('scroll', () => updateScrollHint(element), { passive: true });

          if ('ResizeObserver' in window) {
            new ResizeObserver(() => updateScrollHint(element)).observe(element);
          }
        }

        updateScrollHint(element);
      });
    });
  };

  refreshScrollHints();
  window.addEventListener('load', refreshScrollHints);
  window.addEventListener('resize', refreshScrollHints);

  if (document.fonts?.ready) {
    document.fonts.ready.then(refreshScrollHints).catch(() => {});
  }

  document.querySelectorAll('.colegios-selector__icon-stack').forEach((iconStack) => {
    iconStack.closest('.colegios-selector__icon')?.classList.add('colegios-selector__icon--custom');
  });

  const normalizePropertyKey = (key) => String(key || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

  const normalizeUppercasePropertyValue = (value) => String(value || '')
    .toLocaleUpperCase('es-MX')
    .replace(/[^A-ZÁÉÍÓÚÜÑ ]/g, '');

  const getLinePropertyName = (input) => {
    const propertyName = input?.dataset?.propertyName;

    if (propertyName) return propertyName;

    const nameMatch = String(input?.name || '').match(/^properties\[(.+)\]$/);

    return nameMatch?.[1] || '';
  };

  const getLinePropertyInput = (container, propertyName) => {
    const normalizedPropertyName = normalizePropertyKey(propertyName);
    const inputs = container.querySelectorAll('[name^="properties["], [data-property-name]');

    return Array.from(inputs).find((input) => normalizePropertyKey(getLinePropertyName(input)) === normalizedPropertyName);
  };

  const getLogoFromSection = (section) => ({
    queretano: 'PRIMARIA',
    'san javier': 'SAN JAVIER',
    vespertina: 'VESPERTINO',
  }[normalizePropertyKey(section)] || '');

  const getLogoSubmitInput = (form) => {
    let logoInput = form.querySelector('[data-logo-submit]');

    if (!logoInput) {
      logoInput = document.createElement('input');
      logoInput.type = 'hidden';
      logoInput.name = 'properties[LOGOTIPO]';
      logoInput.dataset.logoSubmit = '';
      form.append(logoInput);
    }

    return logoInput;
  };

  const getLogoDisplayInput = (form, sectionInput) => {
    const existingDisplayInput = form.querySelector('[data-logo-display]');

    if (existingDisplayInput) return existingDisplayInput;

    const sectionField = sectionInput.closest('.product-property-field, .product-bundle__field');
    const isBundleField = sectionField?.classList.contains('product-bundle__field');
    const displayId = `${sectionInput.id || 'LinePropertySection'}-Logo`;

    if (isBundleField) {
      const displayField = document.createElement('label');
      displayField.className = 'product-bundle__field';
      displayField.innerHTML = `
        <span>LOGOTIPO</span>
        <input id="${escapeHtml(displayId)}" type="text" value="" disabled data-logo-display>
      `;
      sectionField.after(displayField);

      return displayField.querySelector('[data-logo-display]');
    }

    const displayField = document.createElement('div');
    displayField.className = 'product-property-field product-property-field--text product-property-field--key-logotipo';
    displayField.innerHTML = `
      <label class="product-property-field__label" for="${escapeHtml(displayId)}">LOGOTIPO</label>
      <input id="${escapeHtml(displayId)}" type="text" class="product-property-field__control" value="" disabled data-logo-display>
    `;

    if (sectionField) {
      sectionField.after(displayField);
    } else {
      form.append(displayField);
    }

    return displayField.querySelector('[data-logo-display]');
  };

  const syncLogoLineProperty = (form) => {
    const sectionInput = getLinePropertyInput(form, 'SECCIÓN');

    if (!sectionInput) return;

    const existingLogoInput = getLinePropertyInput(form, 'LOGOTIPO');
    const logoInput = getLogoSubmitInput(form);
    const logoDisplayInput = getLogoDisplayInput(form, sectionInput);
    const logoValue = getLogoFromSection(sectionInput.value);

    if (existingLogoInput && existingLogoInput !== logoInput) {
      existingLogoInput.value = logoValue;
      existingLogoInput.disabled = true;
    }

    logoInput.value = logoValue;
    logoDisplayInput.value = logoValue;
  };

  const applyLogoLineProperty = (properties) => {
    const sectionEntry = Object.entries(properties)
      .find(([key, value]) => value && normalizePropertyKey(key) === 'seccion');

    if (!sectionEntry) return properties;

    const logoValue = getLogoFromSection(sectionEntry[1]);

    if (logoValue) {
      properties.LOGOTIPO = logoValue;
    }

    return properties;
  };

  const syncUppercaseInput = (input) => {
    const nextValue = normalizeUppercasePropertyValue(input.value);

    if (input.value !== nextValue) {
      input.value = nextValue;
    }
  };

  const bindUppercaseInput = (input) => {
    input.addEventListener('input', () => syncUppercaseInput(input));
    input.addEventListener('blur', () => syncUppercaseInput(input));
  };

  const isDepositCartItem = (item = {}) => {
    const normalizedItem = normalizePropertyKey([
      item.handle,
      item.product_title,
      item.title,
      item.url,
    ].join(' '));

    return normalizedItem.includes('apartado de propuesta')
      || normalizedItem.includes('apartado-de-propuesta')
      || normalizedItem.includes('apartado de diseno')
      || normalizedItem.includes('apartado-de-diseno');
  };

  const renderPropertyValue = (value) => {
    const normalizedValue = String(value || '').trim();

    if (!normalizedValue) return '';

    if (normalizedValue.includes('/uploads/') || /^https?:\/\//i.test(normalizedValue)) {
      const label = normalizedValue.includes('/uploads/')
        ? normalizedValue.split('/').pop()
        : normalizedValue;

      return `<a href="${escapeHtml(normalizedValue)}" target="_blank" rel="noopener">${escapeHtml(label)}</a>`;
    }

    return escapeHtml(normalizedValue);
  };

  const renderCartProperties = (properties = {}, item = {}) => {
    if (isDepositCartItem(item)) return '';

    const visibleEntries = Object.entries(properties)
      .filter(([key, value]) => value && !key.startsWith('_'));
    const detailEntries = [];
    let personalizationName = '';
    let playerNumber = '';

    visibleEntries.forEach(([key, value]) => {
      const normalizedKey = normalizePropertyKey(key);

      if (!personalizationName && (normalizedKey.includes('personalizado') || normalizedKey.includes('nombre del jugador'))) {
        personalizationName = value;
        return;
      }

      if (!playerNumber && normalizedKey.includes('numero de jugador')) {
        playerNumber = value;
        return;
      }

      detailEntries.push([key, value]);
    });

    const rows = detailEntries
      .map(([key, value]) => `
        <div>
          <dt>${escapeHtml(key)}</dt>
          <dd>${renderPropertyValue(value)}</dd>
        </div>
      `)
      .join('');
    const customLine = personalizationName || playerNumber
      ? `<p class="cart-drawer__custom-line">( ${playerNumber ? `# ${escapeHtml(playerNumber)}` : ''}${playerNumber && personalizationName ? ' / ' : ''}${personalizationName ? escapeHtml(String(personalizationName)) : ''} )</p>`
      : '';

    return `${rows ? `<dl class="cart-drawer__properties">${rows}</dl>` : ''}${customLine}`;
  };

  const getCartContinueUrl = (cart = {}) => {
    const fallbackUrl = cartLabels.continueUrl || cartLabels.collectionsUrl || '/pages/colegios';
    const schoolItem = (cart.items || []).find((item) => !isDepositCartItem(item));
    const properties = schoolItem?.properties || {};
    const configuredUrl = properties['_Continuar comprando URL'];
    const schoolHandle = properties['_Colegio handle'];

    if (configuredUrl) return configuredUrl;

    const normalizedSchoolHandle = normalizeSchoolSlug(schoolHandle);

    if (normalizedSchoolHandle) {
      return `/pages/colegios?colegio=${encodeURIComponent(normalizedSchoolHandle)}`;
    }

    return fallbackUrl;
  };

  const cartRequiresCheckoutConfirmation = (cart = {}) => (cart.items || []).some((item) => (
    !isDepositCartItem(item) && item.requires_shipping !== false
  ));

  const renderCheckoutConfirmation = (inputId = 'CartDrawerCheckoutConfirmation') => `
    <div class="checkout-confirmation cart-drawer__confirmation" data-checkout-confirmation>
      <label class="checkout-confirmation__label" for="${escapeHtml(inputId)}">
        <input id="${escapeHtml(inputId)}" type="checkbox" required data-checkout-confirmation-input>
        <span>Tu prenda es única y se fabrica especialmente para ti. Verifica talla, nombre y número antes de pagar. Una vez confirmado el pedido, NO SE ACEPTAN CAMBIOS NI DEVOLUCIONES.</span>
      </label>
      <p class="checkout-confirmation__error" data-checkout-confirmation-error hidden>Confirma que revisaste tus datos antes de continuar.</p>
    </div>
  `;

  const updateCheckoutConfirmation = (confirmation) => {
    const checkbox = confirmation?.querySelector('[data-checkout-confirmation-input]');
    const form = confirmation?.closest('form');
    const checked = Boolean(checkbox?.checked);

    if (!checkbox || !form) return;

    form.querySelectorAll('button[name="checkout"], input[name="checkout"][type="submit"]').forEach((button) => {
      button.disabled = !checked;
    });

    form.querySelectorAll('[data-checkout-confirmation-gated]').forEach((element) => {
      element.hidden = !checked;
    });

    if (checked) {
      checkbox.removeAttribute('aria-invalid');
      confirmation.classList.remove('has-error');

      const error = confirmation.querySelector('[data-checkout-confirmation-error]');
      if (error) error.hidden = true;
    }
  };

  const refreshCheckoutConfirmations = (root = document) => {
    root.querySelectorAll('[data-checkout-confirmation]').forEach(updateCheckoutConfirmation);
  };

  const validateCheckoutConfirmation = (form) => {
    const confirmation = form.querySelector('[data-checkout-confirmation]');
    const checkbox = confirmation?.querySelector('[data-checkout-confirmation-input]');

    if (!confirmation || !checkbox || checkbox.checked) return true;

    const error = confirmation.querySelector('[data-checkout-confirmation-error]');

    checkbox.setAttribute('aria-invalid', 'true');
    confirmation.classList.add('has-error');

    if (error) error.hidden = false;

    checkbox.focus();

    return false;
  };

  const renderCartItem = (item) => {
    const isDeposit = isDepositCartItem(item);
    const image = item.image && !isDeposit
      ? `
        <a class="cart-drawer__image" href="${escapeHtml(item.url)}">
          <img src="${escapeHtml(item.image)}" width="72" height="72" alt="${escapeHtml(item.product_title)}" loading="lazy">
        </a>
      `
      : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title'
      ? `<p class="cart-drawer__variant">Talla: ${escapeHtml(item.variant_title)}</p>`
      : '';

    return `
      <article class="cart-drawer__item${isDeposit ? ' cart-drawer__item--deposit' : ''}">
        ${image}
        <div class="cart-drawer__item-content">
          <a class="cart-drawer__item-title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>
          ${variant}
          ${renderCartProperties(item.properties, item)}
          <div class="cart-drawer__item-meta">
            <div class="cart-drawer__quantity" aria-label="Cantidad">
              <button type="button" data-cart-quantity data-line-key="${escapeHtml(item.key)}" data-quantity="${Math.max(item.quantity - 1, 0)}" aria-label="Reducir cantidad de ${escapeHtml(item.product_title)}">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-quantity data-line-key="${escapeHtml(item.key)}" data-quantity="${item.quantity + 1}" aria-label="Aumentar cantidad de ${escapeHtml(item.product_title)}">+</button>
            </div>
            <strong>${formatMoney(item.final_line_price)}</strong>
          </div>
          <button class="cart-drawer__remove" type="button" data-cart-remove data-line-key="${escapeHtml(item.key)}">Eliminar</button>
        </div>
      </article>
    `;
  };

  const renderCartDrawer = (cart) => {
    if (!cartDrawerPanel) return;

    cartDrawerPanel.querySelectorAll('.cart-drawer__items, .cart-drawer__summary, .cart-drawer__actions, .cart-drawer__empty').forEach((element) => {
      element.remove();
    });

    if (!cart.item_count) {
      const continueUrl = getCartContinueUrl(cart);

      cartDrawerPanel.insertAdjacentHTML('beforeend', `
        <div class="cart-drawer__empty">
          <h3>${escapeHtml(cartLabels.emptyTitle)}</h3>
          <p>${escapeHtml(cartLabels.emptyText)}</p>
          <a class="cart-drawer__button" href="${escapeHtml(continueUrl)}">${escapeHtml(cartLabels.continueLabel)}</a>
        </div>
      `);
      updateCartCount(0);
      return;
    }

    const continueUrl = getCartContinueUrl(cart);

    cartDrawerPanel.insertAdjacentHTML('beforeend', `
      <div class="cart-drawer__items">
        ${cart.items.map(renderCartItem).join('')}
      </div>
      <div class="cart-drawer__summary">
        <span>Subtotal</span>
        <strong>${formatMoney(cart.total_price)}</strong>
      </div>
      <div class="cart-drawer__actions">
        <a class="cart-drawer__button cart-drawer__button--ghost" href="${escapeHtml(continueUrl)}">${escapeHtml(cartLabels.continueLabel)}</a>
        <a class="cart-drawer__button cart-drawer__button--secondary" href="${escapeHtml(cartLabels.cartUrl)}">${escapeHtml(cartLabels.cartLabel)}</a>
        <form action="${escapeHtml(cartLabels.cartUrl)}" method="post">
          ${cartRequiresCheckoutConfirmation(cart) ? renderCheckoutConfirmation('CartDrawerCheckoutConfirmationDynamic') : ''}
          <button class="cart-drawer__button" type="submit" name="checkout">${escapeHtml(cartLabels.checkoutLabel)}</button>
        </form>
      </div>
    `);

    updateCartCount(cart.item_count);
    refreshCheckoutConfirmations(cartDrawerPanel);
  };

  const refreshCartDrawer = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) {
      throw new Error('No se pudo actualizar el carrito.');
    }

    const cart = await response.json();
    renderCartDrawer(cart);
    return cart;
  };

  const updateCartLine = async (lineKey, quantity) => {
    if (!lineKey) return;

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: lineKey,
        quantity: Number(quantity),
      }),
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'No se pudo actualizar el carrito.');
    }

    const cart = await response.json();
    renderCartDrawer(cart);
    return cart;
  };

  const migrateDepositCartProperties = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) return { migrated: false, cart: null };

    let cart = await response.json();
    let migrated = false;

    for (const item of cart.items || []) {
      if (!isDepositCartItem(item)) continue;

      const properties = item.properties || {};
      const hasPublicProperties = Object.entries(properties)
        .some(([key, value]) => value && !key.startsWith('_'));

      if (!hasPublicProperties) continue;

      const privateProperties = Object.entries(properties).reduce((nextProperties, [key, value]) => {
        if (!value) return nextProperties;

        const privateKey = key.startsWith('_') ? key : `_${key}`;
        nextProperties[privateKey] = value;

        return nextProperties;
      }, {});

      const changeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: item.quantity,
          properties: privateProperties,
        }),
      });

      if (!changeResponse.ok) continue;

      cart = await changeResponse.json();
      migrated = true;
    }

    return { migrated, cart };
  };

  migrateDepositCartProperties()
    .then(({ migrated, cart }) => {
      if (!migrated) return;

      if (cart) {
        renderCartDrawer(cart);
      }

      if (window.location.pathname.replace(/\/+$/, '') === '/cart') {
        window.location.reload();
      }
    })
    .catch(() => {});

  document.addEventListener('submit', async (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement) || !form.querySelector('[name="checkout"]')) return;

    if (!validateCheckoutConfirmation(form)) {
      event.preventDefault();
      return;
    }

    const actionPath = new URL(form.action, window.location.origin).pathname.replace(/\/+$/, '');

    if (!actionPath.endsWith('/cart') || form.dataset.depositPropertiesMigrated === 'true') return;

    event.preventDefault();

    try {
      await migrateDepositCartProperties();
    } finally {
      form.dataset.depositPropertiesMigrated = 'true';

      if (!form.querySelector('input[name="checkout"][type="hidden"]')) {
        const checkoutInput = document.createElement('input');
        checkoutInput.type = 'hidden';
        checkoutInput.name = 'checkout';
        checkoutInput.value = '';
        form.append(checkoutInput);
      }

      form.submit();
    }
  });

  document.addEventListener('change', (event) => {
    const checkbox = event.target;

    if (!(checkbox instanceof HTMLInputElement) || !checkbox.matches('[data-checkout-confirmation-input]')) return;

    const confirmation = checkbox.closest('[data-checkout-confirmation]');
    updateCheckoutConfirmation(confirmation);
  });

  refreshCheckoutConfirmations();

  document.querySelectorAll('[data-cart-shipping-estimator]').forEach((summary) => {
    const country = summary.dataset.shippingCountry?.trim();
    const province = summary.dataset.shippingProvince?.trim();
    const subtotal = Number(summary.dataset.cartSubtotal || 0);
    const zipInput = summary.querySelector('[data-cart-shipping-zip]');
    const calculateButton = summary.querySelector('[data-cart-shipping-calculate]');
    const shippingTarget = summary.querySelector('[data-cart-shipping-price]');
    const totalTarget = summary.querySelector('[data-cart-total]');
    const emptyLabel = summary.dataset.shippingEmptyLabel || 'Ingresa tu CP';
    const calculatingLabel = summary.dataset.shippingCalculatingLabel || 'Calculando...';
    const fallbackLabel = summary.dataset.shippingFallbackLabel || 'Calculado al finalizar compra';
    const unavailableLabel = summary.dataset.shippingUnavailableLabel || fallbackLabel;
    const wait = (delay) => new Promise((resolve) => window.setTimeout(resolve, delay));
    let latestRequestId = 0;

    if (!shippingTarget || !totalTarget || !country) {
      if (shippingTarget) shippingTarget.textContent = fallbackLabel;
      return;
    }

    const setPendingZipState = () => {
      shippingTarget.textContent = emptyLabel;
      totalTarget.textContent = formatMoney(subtotal);
    };

    const buildShippingQuery = (zip) => {
      const params = new URLSearchParams();
      params.set('shipping_address[country]', country);
      params.set('shipping_address[zip]', zip);

      if (province) {
        params.set('shipping_address[province]', province);
      }

      return params.toString();
    };

    const getRates = async (query) => {
      const response = await fetch(shopifyAjaxUrl(`cart/async_shipping_rates.json?${query}`), {
        headers: { Accept: 'application/json' },
      });

      if (!response.ok) return null;

      return response.json();
    };

    const updateShippingEstimate = async () => {
      const zip = zipInput?.value.trim();

      if (!zip) {
        setPendingZipState();
        return;
      }

      const requestId = latestRequestId + 1;
      latestRequestId = requestId;
      const query = buildShippingQuery(zip);
      shippingTarget.textContent = calculatingLabel;

      const prepareResponse = await fetch(shopifyAjaxUrl(`cart/prepare_shipping_rates.json?${query}`), {
        method: 'POST',
        headers: { Accept: 'application/json' },
      });

      if (!prepareResponse.ok) {
        throw new Error('Shipping rates unavailable');
      }

      let result = null;

      for (let attempt = 0; attempt < 6; attempt += 1) {
        result = await getRates(query);

        if (result?.shipping_rates?.length) break;

        await wait(450);
      }

      if (requestId !== latestRequestId) return;

      const selectedRate = (result?.shipping_rates || [])
        .map((rate) => ({
          ...rate,
          priceCents: parseRatePriceToCents(rate.price),
        }))
        .filter((rate) => rate.priceCents !== null)
        .sort((firstRate, secondRate) => firstRate.priceCents - secondRate.priceCents)[0];

      if (!selectedRate) {
        shippingTarget.textContent = unavailableLabel;
        totalTarget.textContent = formatMoney(subtotal);
        return;
      }

      shippingTarget.textContent = formatMoney(selectedRate.priceCents);
      totalTarget.textContent = formatMoney(subtotal + selectedRate.priceCents);
    };

    setPendingZipState();

    calculateButton?.addEventListener('click', () => {
      updateShippingEstimate().catch(() => {
        shippingTarget.textContent = unavailableLabel;
        totalTarget.textContent = formatMoney(subtotal);
      });
    });

    zipInput?.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter') return;

      event.preventDefault();
      calculateButton?.click();
    });

    zipInput?.addEventListener('input', () => {
      if (!zipInput.value.trim()) {
        setPendingZipState();
      }
    });

    updateShippingEstimate().catch(() => {
      shippingTarget.textContent = unavailableLabel;
      totalTarget.textContent = formatMoney(subtotal);
    });
  });

  const closeMenus = () => {
    mobileMenus.forEach((menu) => menu.removeAttribute('open'));
  };

  const openCartDrawer = () => {
    if (!cartDrawer) return;

    closeMenus();
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');

    cartDrawerTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'true');
    });

    window.setTimeout(() => cartDrawerPanel?.focus(), 80);
  };

  const closeCartDrawer = () => {
    if (!cartDrawer) return;

    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');

    cartDrawerTriggers.forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMenus();
      closeCartDrawer();
    }
  });

  mobileMenus.forEach((menu) => {
    menu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        menu.removeAttribute('open');
      });
    });
  });

  productForms.forEach((form) => {
    const variantSelect = form.querySelector('[data-product-variant-select]');
    const priceTarget = document.querySelector('[data-product-price]');
    const numberInputs = form.querySelectorAll('[data-number-only]');
    const uppercaseInputs = form.querySelectorAll('[data-uppercase-only]');
    const sectionInput = getLinePropertyInput(form, 'SECCIÓN');
    const backButton = form.querySelector('[data-product-back-button]');
    const submitButton = form.querySelector('[type="submit"]');

    variantSelect?.addEventListener('change', () => {
      const selectedOption = variantSelect.options[variantSelect.selectedIndex];

      if (priceTarget && selectedOption?.dataset.price) {
        priceTarget.textContent = selectedOption.dataset.price;
      }
    });

    numberInputs.forEach((input) => {
      input.addEventListener('input', () => {
        input.value = input.value.replace(/\D/g, '');
      });
    });

    uppercaseInputs.forEach(bindUppercaseInput);
    sectionInput?.addEventListener('change', () => syncLogoLineProperty(form));
    syncLogoLineProperty(form);

    backButton?.addEventListener('click', () => {
      const fallbackUrl = backButton.dataset.fallbackUrl || '/pages/colegios';
      const storedReturnUrl = getStoredProductReturnUrl();

      if (storedReturnUrl) {
        window.location.href = storedReturnUrl;
        return;
      }

      try {
        const referrerUrl = document.referrer ? new URL(document.referrer) : null;

        if (referrerUrl?.origin === window.location.origin && window.history.length > 1) {
          window.history.back();
          return;
        }
      } catch (error) {
        // Fall back to the configured URL if the referrer cannot be parsed.
      }

      window.location.href = fallbackUrl;
    });

    form.addEventListener('submit', async (event) => {
      if (!cartDrawer) return;

      event.preventDefault();
      uppercaseInputs.forEach(syncUppercaseInput);
      syncLogoLineProperty(form);
      submitButton?.setAttribute('disabled', 'disabled');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: new FormData(form),
          headers: { Accept: 'application/json' },
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'No se pudo agregar el producto al carrito.');
        }

        await refreshCartDrawer();
        openCartDrawer();
      } catch (error) {
        window.alert(error.message);
      } finally {
        submitButton?.removeAttribute('disabled');
      }
    });
  });

  document.querySelectorAll('[data-deposit-product]').forEach((depositProduct) => {
    const form = depositProduct.querySelector('form');
    const screens = Array.from(depositProduct.querySelectorAll('[data-deposit-screen]'));
    const bankToggle = depositProduct.querySelector('[data-deposit-bank-toggle]');
    const bankDetails = depositProduct.querySelector('[data-deposit-bank-details]');

    const setDepositScreen = (target) => {
      screens.forEach((screen) => {
        const isActive = screen.dataset.depositScreen === target;
        screen.hidden = !isActive;
        screen.classList.toggle('is-active', isActive);
      });

      depositProduct.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    depositProduct.querySelectorAll('[data-deposit-next], [data-deposit-prev]').forEach((button) => {
      button.addEventListener('click', () => {
        if (button.matches('[data-deposit-validate]') && form && !form.reportValidity()) {
          return;
        }

        setDepositScreen(button.dataset.depositTarget);
      });
    });

    bankToggle?.addEventListener('click', () => {
      if (!bankDetails) return;

      bankDetails.hidden = !bankDetails.hidden;
    });
  });

  document.querySelectorAll('[data-product-bundle]').forEach((form) => {
    const bundleItems = Array.from(form.querySelectorAll('[data-bundle-item]'));
    const totalTarget = form.querySelector('[data-bundle-total]');
    const countTarget = form.querySelector('[data-bundle-count]');
    const submitButton = form.querySelector('[data-bundle-submit]');
    const propertyInputs = Array.from(form.querySelectorAll('[data-bundle-property]'));
    const uppercaseInputs = Array.from(form.querySelectorAll('[data-uppercase-only]'));
    const itemsLabel = form.dataset.bundleItemsLabel || 'prendas seleccionadas';
    const submitLabel = submitButton?.textContent || '';

    const getCheckbox = (item) => item.querySelector('[data-bundle-checkbox]');
    const getVariantSelect = (item) => item.querySelector('[data-bundle-variant-select]');
    const getVariantInput = (item) => item.querySelector('[data-bundle-variant-id]');

    const getVariantId = (item) => {
      const select = getVariantSelect(item);
      const input = getVariantInput(item);

      return select?.value || input?.value || '';
    };

    const getVariantPrice = (item) => {
      const select = getVariantSelect(item);
      const input = getVariantInput(item);

      if (select) {
        const selectedOption = select.options[select.selectedIndex];
        return Number(selectedOption?.dataset.price || 0);
      }

      return Number(input?.dataset.price || 0);
    };

    const getSelectedItems = () => bundleItems.filter((item) => {
      const checkbox = getCheckbox(item);

      return checkbox?.checked && !checkbox.disabled && getVariantId(item);
    });

    const updateBundleItem = (item) => {
      const checkbox = getCheckbox(item);
      const priceTarget = item.querySelector('[data-bundle-item-price]');

      item.classList.toggle('is-selected', Boolean(checkbox?.checked && !checkbox.disabled));

      if (priceTarget) {
        priceTarget.textContent = formatMoney(getVariantPrice(item));
      }
    };

    const updateBundleTotal = () => {
      const selectedItems = getSelectedItems();
      const total = selectedItems.reduce((sum, item) => sum + getVariantPrice(item), 0);

      if (totalTarget) {
        totalTarget.textContent = formatMoney(total);
      }

      if (countTarget) {
        countTarget.textContent = `${selectedItems.length} ${itemsLabel}`;
      }

      if (submitButton) {
        submitButton.disabled = selectedItems.length === 0;
      }
    };

    propertyInputs.forEach((input) => {
      if (input.matches('[data-bundle-number-only]')) {
        input.addEventListener('input', () => {
          input.value = input.value.replace(/\D/g, '');
        });
      }
    });

    uppercaseInputs.forEach(bindUppercaseInput);

    bundleItems.forEach((item) => {
      const checkbox = getCheckbox(item);
      const variantSelect = getVariantSelect(item);

      updateBundleItem(item);

      checkbox?.addEventListener('change', () => {
        updateBundleItem(item);
        updateBundleTotal();
      });

      variantSelect?.addEventListener('change', () => {
        updateBundleItem(item);
        updateBundleTotal();
      });
    });

    updateBundleTotal();

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const selectedItems = getSelectedItems();

      if (!selectedItems.length) {
        window.alert('Selecciona al menos una prenda del paquete.');
        return;
      }

      uppercaseInputs.forEach(syncUppercaseInput);

      if (!form.reportValidity()) {
        return;
      }

      const properties = applyLogoLineProperty(propertyInputs.reduce((result, input) => {
        const propertyName = input.dataset.propertyName;
        const propertyValue = input.value.trim();

        if (propertyName && propertyValue) {
          result[propertyName] = propertyValue;
        }

        return result;
      }, {}));

      const items = selectedItems.map((item) => ({
        id: Number(getVariantId(item)),
        quantity: 1,
        properties: Object.keys(properties).length ? { ...properties } : undefined,
      }));

      submitButton?.setAttribute('disabled', 'disabled');
      if (submitButton) {
        submitButton.textContent = 'Agregando...';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'No se pudo agregar el paquete al carrito.');
        }

        if (cartDrawer) {
          await refreshCartDrawer();
          openCartDrawer();
          return;
        }

        window.location.href = '/cart';
      } catch (error) {
        window.alert(error.message);
      } finally {
        if (submitButton) {
          submitButton.textContent = submitLabel;
          submitButton.removeAttribute('disabled');
        }

        updateBundleTotal();
      }
    });
  });

  document.querySelectorAll('[data-colegios-selector]').forEach((selector) => {
    const intro = selector.querySelector('[data-selector-step="intro"]');
    const detail = selector.querySelector('[data-selector-step="detail"]');
    const schoolNameTargets = selector.querySelectorAll('[data-selector-school-name]');
    const schoolLogoTargets = selector.querySelectorAll('[data-selector-school-logo]');
    const currentName = selector.querySelector('[data-selector-current-name]');
    const disciplineContainers = selector.querySelectorAll('[data-colegios-disciplines]');
    const panelsContainer = selector.querySelector('[data-colegios-panels]');
    const backButtons = selector.querySelectorAll('[data-colegios-selector-back]');
    const exitButtons = selector.querySelectorAll('[data-colegios-selector-exit]');
    const productAssetsScript = selector.querySelector('[data-colegios-product-assets]');
    const disciplineAssetsScript = selector.querySelector('[data-colegios-discipline-assets]');
    const disciplineButtonTemplates = {};
    const metaDisciplineKeys = new Set(['_disciplines', 'disciplines']);
    let disciplineButtons = selector.querySelectorAll('[data-colegios-discipline]');
    let disciplinePanels = selector.querySelectorAll('[data-discipline-panel]');
    let selectorProductLists = {};
    let productAssets = {};
    let defaultDisciplineAssets = {};
    const productImageCache = new Map();

    const getActiveDiscipline = () => normalizeSchoolSlug(
      Array.from(disciplineButtons).find((button) => button.classList.contains('is-active'))?.dataset.colegiosDiscipline || '',
    );

    const getSelectorStateFromUrl = () => {
      const params = new URLSearchParams(window.location.search);
      const school = normalizeSchoolSlug(params.get('colegio') || window.location.hash.replace(/^#/, ''));
      const discipline = normalizeSchoolSlug(params.get('disciplina') || params.get('deporte') || '');

      return { school, discipline };
    };

    const getSelectorStateUrl = (discipline = getActiveDiscipline()) => {
      const schoolHandle = normalizeSchoolSlug(selector.dataset.selectedSchoolHandle);

      if (!schoolHandle) return '';

      const url = new URL(window.location.href);
      const normalizedDiscipline = normalizeSchoolSlug(discipline);

      url.hash = '';
      url.searchParams.set('colegio', schoolHandle);

      if (normalizedDiscipline) {
        url.searchParams.set('disciplina', normalizedDiscipline);
      } else {
        url.searchParams.delete('disciplina');
        url.searchParams.delete('deporte');
      }

      return `${url.pathname}${url.search}${url.hash}`;
    };

    const updateSelectorHistory = ({ discipline, replace = true } = {}) => {
      if (!window.history?.pushState) return;

      const stateUrl = getSelectorStateUrl(discipline);

      if (!stateUrl || stateUrl === `${window.location.pathname}${window.location.search}${window.location.hash}`) return;

      const historyState = {
        moottColegios: true,
        school: normalizeSchoolSlug(selector.dataset.selectedSchoolHandle),
        discipline: normalizeSchoolSlug(discipline || getActiveDiscipline()),
      };
      const historyMethod = replace ? 'replaceState' : 'pushState';

      window.history[historyMethod](historyState, '', stateUrl);
    };

    const resetSelectorHistory = ({ replace = true } = {}) => {
      if (!window.history?.pushState) return;

      const url = new URL(window.location.href);

      url.hash = '';
      url.searchParams.delete('colegio');
      url.searchParams.delete('disciplina');
      url.searchParams.delete('deporte');

      const stateUrl = `${url.pathname}${url.search}${url.hash}`;

      if (stateUrl === `${window.location.pathname}${window.location.search}${window.location.hash}`) return;

      window.history[replace ? 'replaceState' : 'pushState']({ moottColegios: true }, '', stateUrl);
    };

    disciplineContainers.forEach((container) => {
      const mode = container.dataset.colegiosDisciplines || 'intro';

      container.querySelectorAll('[data-colegios-discipline]').forEach((button) => {
        const disciplineKey = normalizeSchoolSlug(button.dataset.colegiosDiscipline);

        if (disciplineKey) {
          disciplineButtonTemplates[`${mode}:${disciplineKey}`] = button.outerHTML;
        }
      });
    });

    try {
      productAssets = JSON.parse(productAssetsScript?.textContent || '{}');
    } catch (error) {
      productAssets = {};
    }

    try {
      defaultDisciplineAssets = JSON.parse(disciplineAssetsScript?.textContent || '{}');
    } catch (error) {
      defaultDisciplineAssets = {};
    }

    const getEnabledDisciplines = () => (selector.dataset.enabledDisciplines || '')
      .split(',')
      .map((discipline) => normalizeSchoolSlug(discipline))
      .filter(Boolean);

    const normalizeProductUrl = (url, handle = '') => {
      const value = String(url || handle || '').trim();

      if (!value) return '#';
      if (/^(https?:)?\/\//.test(value) || value.startsWith('/') || value.startsWith('#')) return value;

      return `/products/${value.replace(/^products\//, '').replace(/^\/+/, '')}`;
    };

    const getProductHandle = (url, fallbackHandle = '') => {
      const normalizedUrl = normalizeProductUrl(url, fallbackHandle);

      if (fallbackHandle) return fallbackHandle;
      if (!normalizedUrl || normalizedUrl === '#') return '';

      try {
        const parsedUrl = new URL(normalizedUrl, window.location.origin);
        const match = parsedUrl.pathname.match(/\/products\/([^/?#]+)/);

        return match?.[1] ? decodeURIComponent(match[1]) : '';
      } catch (error) {
        const match = normalizedUrl.match(/(?:^|\/)products\/([^/?#]+)/);

        return match?.[1] ? decodeURIComponent(match[1]) : '';
      }
    };

    const getImageSource = (imageValue) => {
      if (!imageValue) return '';
      if (typeof imageValue === 'string') return imageValue;

      return imageValue.src || imageValue.url || imageValue.preview_image?.src || '';
    };

    const parseProductList = (productList) => {
      if (Array.isArray(productList)) {
        return productList.map((product) => {
          if (typeof product === 'string') {
            const handle = getProductHandle(product);

            return {
              title: product,
              subtitle: '',
              url: normalizeProductUrl(product),
              image: '',
              handle,
            };
          }

          const title = product?.title || product?.name || '';
          const subtitle = product?.subtitle || product?.variant || '';
          const handle = product?.handle || getProductHandle(product?.url || '');
          const url = normalizeProductUrl(product?.url || '', handle);
          const image = getImageSource(product?.image || product?.imageUrl || product?.featured_image || product?.featuredImage);

          return { title, subtitle, url, image, handle };
        }).filter((product) => product.title || product.url !== '#');
      }

      if (productList && typeof productList === 'object') {
        return parseProductList(productList.products || []);
      }

      return String(productList || '')
        .split(/\r?\n/)
        .map((line) => line.trim())
        .filter(Boolean)
        .map((line) => {
          const [title = '', subtitle = '', url = '', image = ''] = line.split('|').map((part) => part.trim());
          const handle = getProductHandle(url);

          return { title, subtitle, url: normalizeProductUrl(url, handle), image, handle };
        })
        .filter((product) => product.title);
    };

    const getDisciplineName = (disciplineKey) => {
      const disciplineAsset = defaultDisciplineAssets[disciplineKey] || {};
      const fallbackName = disciplineKey
        .replace(/-/g, ' ')
        .replace(/\b\w/g, (letter) => letter.toUpperCase());

      return disciplineAsset.name || fallbackName;
    };

    const normalizeDisciplineMeta = (discipline) => {
      const key = normalizeSchoolSlug(discipline?.key || discipline?.handle || discipline?.name);

      if (!key) return null;

      const defaults = defaultDisciplineAssets[key] || {};

      return {
        key,
        name: discipline?.name || defaults.name || getDisciplineName(key),
        icon: discipline?.icon || defaults.icon || '',
        mutedIcon: discipline?.mutedIcon || defaults.mutedIcon || '',
        activeIcon: discipline?.activeIcon || defaults.activeIcon || '',
      };
    };

    const getConfiguredDisciplines = () => {
      const disciplineMap = new Map();
      const configuredMeta = Array.isArray(selectorProductLists._disciplines)
        ? selectorProductLists._disciplines
        : Array.isArray(selectorProductLists.disciplines)
          ? selectorProductLists.disciplines
          : [];

      configuredMeta.forEach((discipline) => {
        const normalizedMeta = normalizeDisciplineMeta(discipline);

        if (normalizedMeta) {
          disciplineMap.set(normalizedMeta.key, normalizedMeta);
        }
      });

      Object.keys(selectorProductLists).forEach((disciplineKey) => {
        const normalizedKey = normalizeSchoolSlug(disciplineKey);

        if (!normalizedKey || metaDisciplineKeys.has(disciplineKey)) return;
        if (!parseProductList(selectorProductLists[disciplineKey]).length) return;

        if (!disciplineMap.has(normalizedKey)) {
          disciplineMap.set(normalizedKey, normalizeDisciplineMeta({ key: normalizedKey, name: getDisciplineName(normalizedKey) }));
        }
      });

      const enabledDisciplines = getEnabledDisciplines();
      const configuredDisciplines = enabledDisciplines.length
        ? enabledDisciplines.map((disciplineKey) => (
          disciplineMap.get(disciplineKey) || normalizeDisciplineMeta({ key: disciplineKey, name: getDisciplineName(disciplineKey) })
        )).filter(Boolean)
        : Array.from(disciplineMap.values());

      return configuredDisciplines.filter((discipline) => parseProductList(selectorProductLists[discipline.key]).length);
    };

    const renderCustomIcon = (discipline, mode) => {
      const defaultIcon = mode === 'compact' && discipline.mutedIcon ? discipline.mutedIcon : discipline.icon;
      const activeIcon = mode === 'compact' ? discipline.activeIcon : '';

      if (defaultIcon || activeIcon) {
        return `
          <span class="colegios-selector__icon colegios-selector__icon--custom" aria-hidden="true">
            <span class="colegios-selector__icon-stack colegios-selector__icon-stack--${escapeHtml(mode)}${activeIcon ? ' has-active-icon' : ''}">
              ${defaultIcon ? `<img class="colegios-selector__icon-img colegios-selector__icon-img--default" src="${escapeHtml(defaultIcon)}" width="72" height="72" alt="" loading="lazy">` : ''}
              ${activeIcon ? `<img class="colegios-selector__icon-img colegios-selector__icon-img--active" src="${escapeHtml(activeIcon)}" width="72" height="72" alt="" loading="lazy">` : ''}
            </span>
          </span>
        `;
      }

      return `
        <span class="colegios-selector__icon" aria-hidden="true">
          <span class="colegios-selector__icon-text">${escapeHtml((discipline.name || discipline.key).charAt(0).toUpperCase())}</span>
        </span>
      `;
    };

    const renderDisciplineButton = (discipline, mode) => {
      const template = disciplineButtonTemplates[`${mode}:${discipline.key}`];

      if (template) {
        const holder = document.createElement('div');
        holder.innerHTML = template.trim();
        const button = holder.firstElementChild;
        const label = button?.querySelector('.colegios-selector__label');

        if (button) {
          button.dataset.disciplineName = discipline.name;
          button.setAttribute('aria-pressed', 'false');
          button.classList.remove('is-active');
        }

        if (label) {
          label.textContent = discipline.name;
        }

        return button?.outerHTML || '';
      }

      return `
        <button class="colegios-selector__discipline" type="button" data-colegios-discipline="${escapeHtml(discipline.key)}" data-discipline-name="${escapeHtml(discipline.name)}" aria-pressed="false">
          ${renderCustomIcon(discipline, mode)}
          <span class="colegios-selector__label">${escapeHtml(discipline.name)}</span>
        </button>
      `;
    };

    const refreshDisciplineNodes = () => {
      disciplineButtons = selector.querySelectorAll('[data-colegios-discipline]');
      disciplinePanels = selector.querySelectorAll('[data-discipline-panel]');
    };

    const bindDisciplineButtons = () => {
      disciplineButtons.forEach((button) => {
        if (button.dataset.colegiosDisciplineBound === 'true') return;

        button.dataset.colegiosDisciplineBound = 'true';
        button.addEventListener('click', () => {
          setActiveDiscipline(button.dataset.colegiosDiscipline);
        });
      });
    };

    const renderDisciplineControls = (disciplines) => {
      const disciplineCount = Math.max(disciplines.length, 1);

      disciplineContainers.forEach((container) => {
        const mode = container.dataset.colegiosDisciplines || 'intro';
        container.style.setProperty('--colegios-discipline-count', String(disciplineCount));
        container.innerHTML = disciplines.map((discipline) => renderDisciplineButton(discipline, mode)).join('');
      });

      if (panelsContainer) {
        panelsContainer.innerHTML = disciplines.map((discipline) => (
          `<div class="colegios-selector__panel" data-discipline-panel="${escapeHtml(discipline.key)}"></div>`
        )).join('');
      }

      refreshDisciplineNodes();
      bindDisciplineButtons();
    };

    const hydrateProductImages = (container) => {
      container.querySelectorAll('[data-product-image-handle]').forEach(async (image) => {
        const handle = image.dataset.productImageHandle;

        if (!handle) return;

        if (productImageCache.has(handle)) {
          const cachedImage = productImageCache.get(handle);

          if (cachedImage) image.src = cachedImage;
          return;
        }

        try {
          const response = await fetch(shopifyAjaxUrl(`products/${handle}.js`), {
            headers: { Accept: 'application/json' },
          });

          if (!response.ok) throw new Error('Product image unavailable');

          const product = await response.json();
          const productImage = (
            getImageSource(product.featured_image)
            || getImageSource(product.images?.[0])
            || getImageSource(product.media?.[0])
          );

          productImageCache.set(handle, productImage || '');

          if (productImage) {
            image.src = productImage;
          }
        } catch (error) {
          productImageCache.set(handle, '');
        }
      });
    };

    const getProductImage = (product, discipline) => {
      if (product.image) return product.image;

      const disciplineAssets = productAssets[discipline] || {};
      const fallbackAssets = productAssets.fallbacks || {};
      const catalogKey = normalizeSchoolSlug(`${discipline} ${product.title} ${product.subtitle} ${product.url}`);
      const isWhite = catalogKey.includes('blanc');

      if (catalogKey.includes('short')) {
        return disciplineAssets.short || fallbackAssets.short || fallbackAssets.playera || '';
      }

      if (catalogKey.includes('licra')) {
        return disciplineAssets.licra || fallbackAssets.licra || '';
      }

      if (catalogKey.includes('top')) {
        return disciplineAssets.top || fallbackAssets.top || '';
      }

      if (catalogKey.includes('jersey') || catalogKey.includes('basquetbol')) {
        return (
          disciplineAssets[isWhite ? 'jersey-blanca' : 'jersey-azul']
          || disciplineAssets.jersey
          || fallbackAssets.jersey
          || fallbackAssets.playera
          || ''
        );
      }

      if (catalogKey.includes('playera') || catalogKey.includes('camiseta') || catalogKey.includes('atletismo') || catalogKey.includes('ajedrez')) {
        return (
          disciplineAssets[isWhite ? 'playera-blanca' : 'playera-azul']
          || disciplineAssets.playera
          || fallbackAssets.playera
          || ''
        );
      }

      return fallbackAssets.playera || '';
    };

    const getProductLabel = (product) => {
      const title = product.title || '';
      const subtitle = product.subtitle || '';

      if (!subtitle || normalizeSchoolSlug(title).includes(normalizeSchoolSlug(subtitle))) {
        return title;
      }

      return `${title} ${subtitle}`;
    };

    const renderProductPanels = () => {
      disciplinePanels.forEach((panel) => {
        const discipline = panel.dataset.disciplinePanel;
        const products = parseProductList(selectorProductLists[discipline]);

        if (!products.length) {
          panel.innerHTML = '';
          return;
        }

        panel.innerHTML = products.map((product) => {
          const label = getProductLabel(product);
          const fallbackImage = getProductImage(product, discipline);
          const productHandle = product.handle || getProductHandle(product.url);
          const productUrl = normalizeProductUrl(product.url, productHandle);

          return `
          <a class="colegios-selector__product" href="${escapeHtml(productUrl)}" aria-label="${escapeHtml(label)}">
            <span class="colegios-selector__product-media">
              <img
                ${fallbackImage ? `src="${escapeHtml(fallbackImage)}"` : ''}
                ${productHandle ? `data-product-image-handle="${escapeHtml(productHandle)}"` : ''}
                alt="${escapeHtml(label)}"
                width="1024"
                height="1024"
                loading="lazy"
              >
            </span>
            <span class="colegios-selector__product-label">${escapeHtml(label)}</span>
          </a>
        `;
        }).join('');

        hydrateProductImages(panel);
      });
    };

    const clearActiveDiscipline = () => {
      disciplineButtons.forEach((button) => {
        button.classList.remove('is-active');
        button.setAttribute('aria-pressed', 'false');
      });

      disciplinePanels.forEach((panel) => {
        panel.classList.remove('is-active');
      });

      if (currentName) {
        currentName.textContent = '';
      }
    };

    const setActiveDiscipline = (discipline, revealDetail = true, { updateHistory = true, replaceHistory = true, smooth = true } = {}) => {
      const enabledDisciplines = getEnabledDisciplines();
      const fallbackDiscipline = enabledDisciplines[0] || discipline;

      discipline = normalizeSchoolSlug(discipline);

      if (!discipline) return;
      if (enabledDisciplines.length && !enabledDisciplines.includes(discipline)) {
        discipline = fallbackDiscipline;
      }

      const wasHidden = detail?.hidden;
      const activeButton = Array.from(disciplineButtons).find((button) => button.dataset.colegiosDiscipline === discipline);
      const disciplineName = activeButton?.dataset.disciplineName || '';

      disciplineButtons.forEach((button) => {
        const isActive = button.dataset.colegiosDiscipline === discipline;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      disciplinePanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.disciplinePanel === discipline);
      });

      if (currentName && disciplineName) {
        currentName.textContent = disciplineName;
      }

      if (revealDetail && intro && detail) {
        intro.hidden = true;
        detail.hidden = false;
        refreshScrollHints();

        if (wasHidden) {
          detail.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
        }
      }

      if (updateHistory) {
        updateSelectorHistory({ discipline, replace: replaceHistory });
      }
    };

    const setSchoolIdentity = ({ schoolName, schoolHandle, schoolLogoUrl, schoolLogoAlt } = {}) => {
      const cleanSchoolName = schoolName || '';
      const cleanSchoolLogoUrl = schoolLogoUrl || '';

      selector.dataset.selectedSchoolHandle = schoolHandle || normalizeSchoolSlug(cleanSchoolName);
      selector.classList.toggle('has-school-logo', Boolean(cleanSchoolLogoUrl));

      schoolNameTargets.forEach((target) => {
        target.textContent = cleanSchoolName;
      });

      schoolLogoTargets.forEach((image) => {
        if (cleanSchoolLogoUrl) {
          image.src = cleanSchoolLogoUrl;
          image.alt = schoolLogoAlt || cleanSchoolName;
          image.hidden = false;
          return;
        }

        image.removeAttribute('src');
        image.alt = '';
        image.hidden = true;
      });
    };

    selector.prepareColegiosSelector = ({ schoolName, schoolHandle, schoolLogoUrl, schoolLogoAlt, disciplines, productsByDiscipline } = {}) => {
      selector.dataset.enabledDisciplines = disciplines || '';
      selectorProductLists = productsByDiscipline || {};

      const configuredDisciplines = getConfiguredDisciplines();

      selector.dataset.enabledDisciplines = configuredDisciplines.map((discipline) => discipline.key).join(',');

      setSchoolIdentity({ schoolName, schoolHandle, schoolLogoUrl, schoolLogoAlt });
      renderDisciplineControls(configuredDisciplines);
      renderProductPanels();
      clearActiveDiscipline();
      refreshScrollHints();

      if (intro && detail) {
        intro.hidden = false;
        detail.hidden = true;
      }
    };

    selector.selectColegiosDiscipline = (discipline, options = {}) => {
      setActiveDiscipline(discipline, options.revealDetail ?? true, options);
    };

    selector.getColegiosRequestedState = getSelectorStateFromUrl;
    selector.getColegiosCurrentUrl = getSelectorStateUrl;
    selector.updateColegiosUrl = updateSelectorHistory;
    selector.resetColegiosUrl = resetSelectorHistory;

    bindDisciplineButtons();

    selector.addEventListener('click', (event) => {
      const productLink = event.target.closest('.colegios-selector__product');

      if (!productLink || !selector.contains(productLink)) return;

      const returnUrl = getSelectorStateUrl();

      if (returnUrl) {
        setStoredProductReturnUrl(returnUrl);
      }
    });

    backButtons.forEach((backButton) => {
      backButton.addEventListener('click', () => {
        if (intro && detail) {
          intro.hidden = false;
          detail.hidden = true;
        }

        clearActiveDiscipline();
        updateSelectorHistory();
        refreshScrollHints();

        if (intro) {
          intro.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    exitButtons.forEach((exitButton) => {
      exitButton.addEventListener('click', () => {
        const schoolFlowSections = document.querySelectorAll('[data-colegios-school-flow]');

        if (intro && detail) {
          intro.hidden = false;
          detail.hidden = true;
        }

        clearActiveDiscipline();
        resetSelectorHistory();
        selector.hidden = true;
        schoolFlowSections.forEach((section) => {
          section.hidden = false;
        });
        refreshScrollHints();

        if (schoolFlowSections[0]) {
          schoolFlowSections[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });

  document.querySelectorAll('[data-colegios-school-carousel]').forEach((carousel) => {
    const schoolSection = carousel.closest('[data-colegios-school-section]');
    const selector = document.querySelector('[data-colegios-selector]');
    const schoolSlides = carousel.querySelectorAll('[data-colegios-school-slide]');
    const schoolButtons = carousel.querySelectorAll('[data-colegios-school-select]');
    const galleryPanels = carousel.querySelectorAll('[data-colegios-school-gallery]');
    const previousButton = carousel.querySelector('[data-school-carousel-prev]');
    const nextButton = carousel.querySelector('[data-school-carousel-next]');
    const schoolFlowSections = document.querySelectorAll('[data-colegios-school-flow]');
    let activeIndex = 0;

    const setActiveSchool = (index) => {
      if (!schoolSlides.length) return;

      activeIndex = (index + schoolSlides.length) % schoolSlides.length;

      schoolSlides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.querySelectorAll('[data-colegios-school-select]').forEach((button) => {
          button.tabIndex = isActive ? 0 : -1;
          button.setAttribute('aria-hidden', String(!isActive));
        });
      });

      galleryPanels.forEach((panel, panelIndex) => {
        panel.classList.toggle('is-active', panelIndex === activeIndex);
      });

      if (previousButton && nextButton) {
        previousButton.disabled = schoolSlides.length <= 1;
        nextButton.disabled = schoolSlides.length <= 1;
      }
    };

    previousButton?.addEventListener('click', () => {
      setActiveSchool(activeIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      setActiveSchool(activeIndex + 1);
    });

    const closeSchoolSelector = ({ smooth = true } = {}) => {
      selector?.resetColegiosUrl?.();

      if (selector) {
        selector.hidden = true;
      }

      schoolFlowSections.forEach((section) => {
        section.hidden = false;
      });
      refreshScrollHints();

      if (smooth && schoolFlowSections[0]) {
        schoolFlowSections[0].scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    const openSchoolSelector = (button, { smooth = true, updateHistory = true, replaceHistory = false, discipline = '' } = {}) => {
      const productsScript = button.closest('[data-colegios-school-slide]')?.querySelector('[data-school-products-json]');
      let productsByDiscipline = {};

      try {
        productsByDiscipline = JSON.parse(productsScript?.textContent || '{}');
      } catch (error) {
        productsByDiscipline = {};
      }

      schoolFlowSections.forEach((section) => {
        section.hidden = true;
      });

      if (selector) {
        selector.hidden = false;
        selector.prepareColegiosSelector?.({
          schoolName: button.dataset.schoolName,
          schoolHandle: button.dataset.schoolHandle,
          schoolLogoUrl: button.dataset.schoolLogoUrl,
          schoolLogoAlt: button.dataset.schoolLogoAlt,
          disciplines: button.dataset.schoolDisciplines,
          productsByDiscipline,
        });

        if (discipline) {
          selector.selectColegiosDiscipline?.(discipline, { updateHistory: false, smooth });
        }

        if (updateHistory) {
          selector.updateColegiosUrl?.({ discipline, replace: replaceHistory });
        }

        refreshScrollHints();
        selector.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'start' });
      }
    };

    schoolButtons.forEach((button) => {
      button.addEventListener('click', () => {
        openSchoolSelector(button);
      });
    });

    setActiveSchool(0);

    const applyRequestedSchoolState = ({ smooth = false } = {}) => {
      const requestedState = selector?.getColegiosRequestedState?.() || {};
      const requestedSchool = requestedState.school;
      const requestedDiscipline = requestedState.discipline;

      if (!requestedSchool) {
        closeSchoolSelector({ smooth });
        return false;
      }

      const requestedButton = Array.from(schoolButtons).find((button) => {
        const schoolHandle = normalizeSchoolSlug(button.dataset.schoolHandle || button.dataset.schoolName);
        const schoolName = normalizeSchoolSlug(button.dataset.schoolName);

        return schoolHandle === requestedSchool || schoolName === requestedSchool;
      });

      if (requestedButton) {
        setActiveSchool(Number(requestedButton.dataset.schoolIndex || 0));
        openSchoolSelector(requestedButton, {
          smooth,
          updateHistory: false,
          discipline: requestedDiscipline,
        });
        return true;
      }

      return false;
    };

    if (selector?.getColegiosRequestedState?.().school) {
      applyRequestedSchoolState({ smooth: false });
    }

    window.addEventListener('popstate', () => {
      applyRequestedSchoolState({ smooth: false });
    });
  });

  document.querySelectorAll('[data-collab-page]').forEach((page) => {
    const collaborators = Array.from(page.querySelectorAll('[data-collab-collaborator]'));
    const productPanels = page.querySelectorAll('[data-collab-products-panel]');
    const productRegion = page.querySelector('[data-collab-products-region]');
    const previousButton = page.querySelector('[data-collab-prev]');
    const nextButton = page.querySelector('[data-collab-next]');
    let activeIndex = 0;

    const setActiveCollaborator = (index, { scroll = false } = {}) => {
      if (!collaborators.length) return;

      activeIndex = (index + collaborators.length) % collaborators.length;
      const activeCollaborator = collaborators[activeIndex];
      const collaboratorHandle = activeCollaborator.dataset.collaborator;

      collaborators.forEach((collaborator, collaboratorIndex) => {
        const isActive = collaboratorIndex === activeIndex;
        collaborator.classList.toggle('is-active', isActive);
        collaborator.querySelector('[data-collab-collaborator-select]')?.setAttribute('aria-current', String(isActive));
      });

      productPanels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.collaborator === collaboratorHandle);
      });

      if (previousButton && nextButton) {
        previousButton.disabled = collaborators.length <= 1;
        nextButton.disabled = collaborators.length <= 1;
      }

      if (scroll) {
        productRegion?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    };

    collaborators.forEach((collaborator, index) => {
      collaborator.querySelector('[data-collab-collaborator-select]')?.addEventListener('click', () => {
        setActiveCollaborator(index, { scroll: true });
      });
    });

    previousButton?.addEventListener('click', () => {
      setActiveCollaborator(activeIndex - 1);
    });

    nextButton?.addEventListener('click', () => {
      setActiveCollaborator(activeIndex + 1);
    });

    const requestedCollaborator = normalizeSchoolSlug(window.location.hash.replace(/^#/, ''));
    const requestedIndex = requestedCollaborator
      ? collaborators.findIndex((collaborator) => normalizeSchoolSlug(collaborator.dataset.collaborator) === requestedCollaborator)
      : -1;

    setActiveCollaborator(requestedIndex >= 0 ? requestedIndex : 0);
  });

  document.querySelectorAll('[data-events-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-events-slide]'));
    const previousButton = carousel.querySelector('[data-events-prev]');
    const nextButton = carousel.querySelector('[data-events-next]');
    const dotsContainer = carousel.querySelector('[data-events-dots]');
    let activeIndex = 0;
    let intervalId;

    const setActiveSlide = (index) => {
      if (!slides.length) return;

      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        slide.classList.toggle('is-active', slideIndex === activeIndex);
      });

      dotsContainer?.querySelectorAll('[data-events-dot]').forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });
    };

    const stopAutoplay = () => {
      if (intervalId) {
        window.clearInterval(intervalId);
        intervalId = undefined;
      }
    };

    const startAutoplay = () => {
      stopAutoplay();

      if (slides.length > 1) {
        intervalId = window.setInterval(() => setActiveSlide(activeIndex + 1), 4800);
      }
    };

    slides.forEach((_, slideIndex) => {
      const dot = document.createElement('button');
      dot.className = 'events-carousel__dot';
      dot.type = 'button';
      dot.dataset.eventsDot = '';
      dot.setAttribute('aria-label', `Ver imagen ${slideIndex + 1}`);
      dot.addEventListener('click', () => {
        setActiveSlide(slideIndex);
        startAutoplay();
      });
      dotsContainer?.append(dot);
    });

    previousButton?.addEventListener('click', () => {
      setActiveSlide(activeIndex - 1);
      startAutoplay();
    });

    nextButton?.addEventListener('click', () => {
      setActiveSlide(activeIndex + 1);
      startAutoplay();
    });

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);
    carousel.addEventListener('focusin', stopAutoplay);
    carousel.addEventListener('focusout', startAutoplay);

    if (slides.length <= 1) {
      previousButton?.setAttribute('disabled', 'disabled');
      nextButton?.setAttribute('disabled', 'disabled');
      dotsContainer?.setAttribute('hidden', 'hidden');
    }

    setActiveSlide(0);
    startAutoplay();
  });

  document.querySelectorAll('[data-personalizacion-apparel]').forEach((apparel) => {
    const categoryButtons = Array.from(apparel.querySelectorAll('[data-personalizacion-category]'));
    const products = Array.from(apparel.querySelectorAll('[data-personalizacion-item]'));
    const viewport = apparel.querySelector('[data-personalizacion-viewport]');
    const previousButton = apparel.querySelector('[data-personalizacion-prev]');
    const nextButton = apparel.querySelector('[data-personalizacion-next]');
    const emptyMessage = apparel.querySelector('[data-personalizacion-empty]');
    let activeCategory = categoryButtons.find((button) => button.classList.contains('is-active'))?.dataset.personalizacionCategory
      || categoryButtons[0]?.dataset.personalizacionCategory
      || '';

    const updateArrows = () => {
      if (!viewport || !previousButton || !nextButton) return;

      const hasOverflow = viewport.scrollWidth > viewport.clientWidth + 2;
      previousButton.disabled = !hasOverflow || viewport.scrollLeft <= 2;
      nextButton.disabled = !hasOverflow || viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;
    };

    const setActiveCategory = (category) => {
      activeCategory = category;
      let visibleCount = 0;

      categoryButtons.forEach((button) => {
        const isActive = button.dataset.personalizacionCategory === activeCategory;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      products.forEach((product) => {
        const isVisible = product.dataset.personalizacionItemCategory === activeCategory;
        product.hidden = !isVisible;

        if (isVisible) {
          visibleCount += 1;
        }
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount > 0;
      }

      viewport?.scrollTo({ left: 0, behavior: 'auto' });
      window.requestAnimationFrame(updateArrows);
    };

    categoryButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setActiveCategory(button.dataset.personalizacionCategory);
      });
    });

    previousButton?.addEventListener('click', () => {
      viewport?.scrollBy({ left: -Math.max(viewport.clientWidth * 0.82, 240), behavior: 'smooth' });
    });

    nextButton?.addEventListener('click', () => {
      viewport?.scrollBy({ left: Math.max(viewport.clientWidth * 0.82, 240), behavior: 'smooth' });
    });

    viewport?.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    setActiveCategory(activeCategory);
  });

  document.addEventListener('click', (event) => {
    const openTrigger = event.target.closest('[data-cart-drawer-open]');
    const quantityButton = event.target.closest('[data-cart-quantity]');
    const removeButton = event.target.closest('[data-cart-remove]');

    if (openTrigger) {
      event.preventDefault();
      openCartDrawer();
      return;
    }

    if (quantityButton) {
      event.preventDefault();
      quantityButton.setAttribute('disabled', 'disabled');
      updateCartLine(quantityButton.dataset.lineKey, quantityButton.dataset.quantity)
        .catch((error) => window.alert(error.message))
        .finally(() => quantityButton.removeAttribute('disabled'));
      return;
    }

    if (removeButton) {
      event.preventDefault();
      removeButton.setAttribute('disabled', 'disabled');
      updateCartLine(removeButton.dataset.lineKey, 0)
        .catch((error) => window.alert(error.message))
        .finally(() => removeButton.removeAttribute('disabled'));
      return;
    }

    if (event.target.closest('[data-cart-drawer-close]')) {
      closeCartDrawer();
    }
  });
});
